import { render, staticRenderFns } from "./gwk.vue?vue&type=template&id=5ebe59ef&"
import script from "./gwk.vue?vue&type=script&lang=js&"
export * from "./gwk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports